import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../design/modals/modal/S_Modal';

interface SaveBeforeRejectConfirmationModalProps {
  showSaveBeforeRejectModal: boolean;
  onSaveBeforeRejectConfirm: () => Promise<void>;
  onSaveBeforeRejectDecline: () => Promise<void>;
  onSaveBeforeRejectCancel: () => void;
}

export const SaveBeforeRejectConfirmationModal = observer((props: SaveBeforeRejectConfirmationModalProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_Modal
      isOpen={props.showSaveBeforeRejectModal}
      toggle={props.onSaveBeforeRejectCancel}
      headerText={t('confirmation')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={() => {
              void props.onSaveBeforeRejectDecline();
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={() => {
              void props.onSaveBeforeRejectConfirm();
            }}
          >
            {t('yes_send_image')}
          </Button>
        </>
      }
    >
      {t('reject_annotation_without_reason_confirmation_body')}
    </S_Modal>
  );
});
